import {
    FR_CREATE_EVENT_SUB_PATH,
    FR_EDIT_EVENT_SUB_PATH,
    FR_EVENT_DETAILS_SUB_PATH,
    FR_EVENT_ATTACHMENTS_SUB_PATH,
} from '../router/constants';

export const eventPageSubPathsWithoutRedirect = [
    FR_EVENT_DETAILS_SUB_PATH,
    FR_CREATE_EVENT_SUB_PATH,
    FR_EDIT_EVENT_SUB_PATH,
    FR_EVENT_ATTACHMENTS_SUB_PATH,
];
